/***************************
Ce document permet de définir l'arbre du tunnel.
Chaque noeud est une étapes du parcours.

Racine ____ E1 ___ E3 ____ E finale 1
		|__ E2 ___ E4 ____ E finale 2
				|_ E5 __|

Chaque étapes réprésente un écran du tunnel avec potentiellement des champs à remplir

Cycle de vie d'une étapes:
- Affichage de l'étapes
	-> Affichaque de chaques question
- En fonction de l'état du modèle, certaines cases sont préremplies / selectionnées
- l'utilisateur remplit des champs / sélectionne des réponses
	-> chaque modification update le modèle qui update l'affichage


****************************/
import React from 'react'

import {
    Vue0,
    Vue1,
    Vue2,
    Vue3,
    Vue4,
    Vue5,
    Vue6,
    Vue7,
    Vue9,
    Vue10,
    Vue11,
    Vue12,
    Vue13,
    Vue14,
    Vue15,
    Vue16,
    Vue17,
    Vue18,
    Vue19,
    Vue20,
    Vue21,
    Vue22,
    Vue23,
    Vue24,
    Vue25,
    Vue26,
    Loading,
    ViewNotExist,
} from '../components/ImportVue'

/****************************
Special view for loading for loading state
****************************/
export const loadingView = {
    id: 27,
    id_text: 'ELV',
    description: 'Loading',
    content: <Loading></Loading>,
}

export const step = [
    {
        // 0 : Choix entre les parcours
        id: 0,
        id_text: 'E0',
        description: "Choix d'un parcours",
        content: <Vue0></Vue0>,
    },
    {
        // 1 : Bien trouvé / signé ?
        id: 1,
        id_text: 'E1',
        description: 'Bien trouvé / signé ?',
        content: <Vue1></Vue1>,
    },
    {
        // 2 : Type de projet
        id: 2,
        id_text: 'E2',
        description: 'Type de projet',
        content: <Vue2></Vue2>,
    },
    {
        // 3 : Usage du projet
        id: 3,
        id_text: 'E3',
        description: 'Usage du projet',
        content: <Vue3></Vue3>,
    },
    {
        // 4 : Où se situe votre bien ?
        id: 4,
        id_text: 'E4',
        description: 'Où se situe votre bien ?',
        content: <Vue4></Vue4>,
    },
    {
        // 5 : Montant de l’opération
        // depend grandement des prj_type défini a l'étape 2
        id: 5,
        id_text: 'E5',
        description: 'Montant de l’opération',
        content: <Vue5></Vue5>,
    },
    {
        // 6 : Qui sont les emprunteurs
        id: 6,
        id_text: 'E6',
        description: 'Qui sont les emprunteurs ?',
        content: <Vue6></Vue6>,
    },
    {
        // 7 : Dans votre logement actuel, vous êtes
        id: 7,
        id_text: 'E7',
        description: 'Dans votre logement actuel, vous êtes',
        content: <Vue7></Vue7>,
    },
    {
        // 8
        id: 8,
        id_text: 'E8',
        description: 'Vide',
        content: <div></div>,
    },
    {
        // 9 : Où habitez-vous actuellement ?
        id: 9,
        id_text: 'E9',
        description: 'Où habitez-vous actuellement ?',
        content: <Vue9></Vue9>,
    },
    {
        // 10 : Quelle est votre situation professionnelle ?
        id: 10,
        id_text: 'E10',
        description:
            'Quelle est la situation professionnelle du premier emprunteur? (vous)',
        content: <Vue10></Vue10>,
    },
    {
        // 11 : Quelle est votre situation professionnelle ?
        id: 11,
        id_text: 'E11',
        description: 'Quelle est votre situation professionnelle ?',
        content: <Vue11></Vue11>,
    },
    {
        // 12 : Quelles sont les charges mensuelles de votre foyer ?
        id: 12,
        id_text: 'E12',
        description: 'Quelles sont les charges mensuelles de votre foyer ?',
        content: <Vue12></Vue12>,
    },
    {
        // 13 : Quel est votre apport personnel ?
        id: 13,
        id_text: 'E13',
        description: 'Quel est votre apport personnel ? ',
        content: <Vue13></Vue13>,
    },
    {
        // 14 : Quelle est la durée du prêt souhaitée ?
        id: 14,
        id_text: 'E14',
        description: 'Quelle est la durée du prêt souhaitée ?',
        content: <Vue14></Vue14>,
    },
    {
        // 15 : Avez-vous interrogé des banques ou courtiers pour votre projet ?
        id: 15,
        id_text: 'E15',
        description:
            'Avez-vous interrogé des banques ou courtiers pour votre projet ?',
        content: <Vue15></Vue15>,
    },
    {
        // 16 : Information de contact estimation
        id: 16,
        id_text: 'E16',
        description: 'Information de contact estimation',
        content: <Vue16></Vue16>,
    },
    {
        // 17 : Comparer ou renégocier ?
        id: 17,
        id_text: 'E17',
        description: 'Comparer ou renégocier ?',
        content: <Vue17></Vue17>,
    },
    {
        // 18 : télécharger Offre
        id: 18,
        id_text: 'E18',
        description: 'télécharger Offre',
        content: <Vue18></Vue18>,
    },
    {
        // 19 : Information de contact comparaison offre
        id: 19,
        id_text: 'E19',
        description: 'Information de contact comparaison offre',
        content: <Vue19></Vue19>,
    },
    {
        // 20 : Comparaison offre envoi/fin tunnel
        id: 20,
        id_text: 'E20',
        description: 'Comparaison offre envoi/fin tunnel ',
        content: <Vue20></Vue20>,
    },
    {
        // 21 : Estimation envoi/fin tunnel
        id: 21,
        id_text: 'E21',
        description: 'Estimation envoi/fin tunnel ',
        content: <Vue21></Vue21>,
    },
    {
        // 22 -- equivalent 10 : Quelle est votre situation professionnelle ?
        id: 22,
        id_text: 'E22',
        description: 'Quelle est votre situation professionnelle ?',
        content: <Vue22></Vue22>,
    },
    {
        // 23 équi equivalent 11 : Quelle est votre situation professionnelle ?
        id: 23,
        id_text: 'E23',
        description:
            'Quelle est la situation professionnelle du second emprunteur?',
        content: <Vue23></Vue23>,
    },
    {
        // 24  vérification du numéro de téléphone SMS
        id: 24,
        id_text: 'E24',
        description: 'Vérification du numéro de téléphone',
        content: <Vue24></Vue24>,
    },
    {
        // 25  Crédit a renégocier
        id: 25,
        id_text: 'E25',
        description: 'Crédit à renégocier',
        content: <Vue25></Vue25>,
    },
    {
        // 26  Crédit a renégocier
        id: 26,
        id_text: 'E26',
        description: 'Ajout crédit à renégocier',
        content: <Vue26></Vue26>,
    },
    loadingView,
]

/****************************
Special view for view that don't exist.. 
contain a link to go to home.
****************************/
export const notExistView = {
    // step 0
    id: 1001,
    id_text: 'ENEV',
    description: 'View not exist',
    content: <ViewNotExist></ViewNotExist>,
}

export default step
